/** SPY-207: boots / move-speed fidelity mid-match. */

import { calculateSoftCappedMS } from '../entity/entityMovement.js';

export const BASE_CHAMPION_MS = 325;
export const BOOTS_OF_SPEED_FLAT_MS = 25;
export const BOOTS_ITEM_IDS = Object.freeze(['boots_of_speed']);

export function isBootsItem(itemId) {
  return BOOTS_ITEM_IDS.includes(itemId);
}

export function hasBootsEquipped(slots) {
  if (!slots) return false;
  return slots.some((s) => s && isBootsItem(s.id));
}

/**
 * Unique boots: reject a second boots purchase while one is equipped.
 * Non-boots items always allowed through this gate.
 */
export function canBuyBootsItem(slots, itemId) {
  if (!isBootsItem(itemId)) return true;
  return !hasBootsEquipped(slots);
}

export function computeRawMs({ bonusMs = 0, runeMsPercent = 0 } = {}) {
  return (BASE_CHAMPION_MS + bonusMs) * (1 + runeMsPercent);
}

/**
 * Snapshot helpers for mid-match boots fidelity asserts / telemetry.
 * @param {{ hasBoots?: boolean, runeMsPercent?: number }} opts
 */
export function midMatchBootsMs({ hasBoots = false, runeMsPercent = 0 } = {}) {
  const bonusMs = hasBoots ? BOOTS_OF_SPEED_FLAT_MS : 0;
  const rawMs = computeRawMs({ bonusMs, runeMsPercent });
  return { rawMs, softCappedMs: calculateSoftCappedMS(rawMs), bonusMs };
}
